(function(){

	//opentable widget hide and show
	// const open_table_widget = document.querySelector('.opentable');
    // const opentable_full_widget = {
    //     opentable_open: document.querySelector('.opentable-trigger-js')
    // };
	// const opentable_full_widget_close = {
	// 	opentable_close: document.querySelector('.close-booking-js')
	// };

	// if(open_table_widget) {
	// 	opentable_full_widget.opentable_open.addEventListener('click', function () {
	// 		open_table_widget.classList.add('expanded'),
	// 		this.innerHTML = '<span class="close-booking-js">Close</span>',
	// 		this.classList.remove('opentable-trigger-js'),
	// 		this.classList.add('close-booking-js')
	// 	});
	// }

	// if(opentable_full_widget_close) {
	// 	opentable_full_widget_close.opentable_close.addEventListener('click', function () {
	// 		open_table_widget.classList.remove('expanded'),
	// 		this.innerHTML = 'Remove',
	// 		this.classList.remove('close-booking-js'),
	// 		this.classList.add('opentable-trigger-js')
	// 	});
	// } 

	//full navigation
    const fullnav = document.querySelector('.header__nav-holder'); 
    const primaryNav = { 
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };

    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
        });
    }

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
		// 	resizeWindow();
		}); 
		// resizeWindow();

		$('.header__opentable-trigger').click(function() {
			$('.opentable').toggleClass('expanded');
			if ($('.opentable').hasClass("expanded")) {
				$('.header__opentable-trigger').html("Close X");
			} else {
				$('.header__opentable-trigger').html("Reserve");
			}
		});

		
	}); 

}());